// Modules
import React from 'react'
import { Container } from './style'
import { Icon } from '@dasa-health/components-react'
import { InfoRound } from '@dasa-health/alma-icons'

export const RevenueDataInformation = () => (
    <Container>
        <Icon className="footer__icon" data-testid="footer-icon" size="large" variant="primary">
            <InfoRound color="#575757" />
        </Icon>
        <p>Informação preenchida automaticamente</p>
    </Container>
)
